import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  TextField,
  Button,
  Typography,
  Grid,
  TextareaAutosize,
  DialogActions 
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import TextBoxWithCheckbox from './TextBoxWithCheckbox';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { styled } from '@mui/material/styles';
import { decrypt, encrypt } from '../../../Security';



const AddAgendaPopup = ({ setAgendas,agendas,handleOpen,handleClose }) => {
  const [title, setTitle] = useState('');
  const [detail, setDetail] = useState('');
  const [checkpoints, setCheckpoints] = useState([]);


  const addCheckPoint = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setCheckpoints((chp) => [...chp, { text: '', checkedState: false }]);
  };

  const updateDB=async(newAgendas)=>{
    try{
        const repId=window.location.href.split('/').pop()
        console.log('updating agenda db there..',newAgendas)
        const url = process.env.REACT_APP_PUBLIC_SERVER_URI + '/adminWeb/repAgenda/update'
        const response = await fetch(url, {
            method: 'PATCH',
            headers: {
              'Content-Type': 'application/json' // Specify Content-Type header
            },
            credentials:'include',
            body:encrypt({agendas:newAgendas,repId})
    
          });
        
          let data = decrypt(await response.json()); // Parse response as JSON
          if (data.msg=="SUCCESS") { 
            setAgendas(data.political_positions)
              alert('Agenda Updated in Database successfully!')
               
          }
          else {
            // console('Error while fetching feeds..'+ data.msg)
            alert('Erorr while updating Agenda: '+data.msg)
          }
    }
    catch(err){
        alert(err)
        
    }
}

  const addAgenda=()=>{
    // console.log('setting agenda from addAgenda=(5)')
    updateDB([{'topic':title,'detail':detail,'checkPoints':checkpoints},...agendas])
    // setAgendas((agd)=>[{'topic':title,'detail':detail,'checkPoints':checkpoints},...agd])
  }

  const removeCheckpoint = (checkpoint, e) => {
    const newCheckpoints = checkpoints.filter((cp) => cp !== checkpoint);
    setCheckpoints(newCheckpoints);
  };

  return (
    <>


        <DialogTitle>
          <IconButton
            onClick={handleClose}
            style={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: 'grey',
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <Grid container>
            <Grid item xs={12}>
              <TextField
                variant="outlined"
                required
                fullWidth
                style={{ marginTop: '30px', backgroundColor: 'white' }}
                id="title"
                label="Title"
                name="title"
                autoComplete="title"
                value={title}
                onChange={(event) => setTitle(event.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6} sx={{ mt: 2 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'black', mb: 1 }}>
                Description
              </Typography>
              <TextareaAutosize
                variant="outlined"
                required
                minRows={7}
                placeholder="Description"
                style={{ marginBottom: '0', width: '100%', borderRadius: '5px', borderColor: 'gray', fontSize: '15px' }}
                id="detail"
                label="Description"
                name="detail"
                autoComplete="detail"
                value={detail}
                onChange={(event) => setDetail(event.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6} sx={{ mt: 2 }}>
              <Grid item xs={12}>
                <Button
                  type="button"
                  variant="contained"
                  color="primary"
                  startIcon={<AddCircleOutlineIcon />}
                  style={{ float: 'right', textTransform: 'none', fontSize: '12px', marginBottom: '10px' }}
                  onClick={addCheckPoint}
                >
                  Checkpoints
                </Button>
              </Grid>
              <Grid item xs={12}>
                {checkpoints.map((checkpoint, index) => (
                  <TextBoxWithCheckbox 
                    key={index} 
                    checkpoint={checkpoint} 
                    checkpoints={checkpoints} 
                    setCheckpoints={setCheckpoints} 
                    id={index} 
                    removeCheckpoint={(e) => removeCheckpoint(checkpoint, e)}
                  />
                ))}
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button 
            sx={{ backgroundColor: 'white',width:'150px',textTransform:'none',color:'black' }}
            onClick={handleClose}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button 
            type="button"
            variant="contained"
            color="primary"
            onClick={addAgenda}
            sx={{width:'150px',textTransform:'none' }}
          >
            Add Agenda
          </Button>
        </DialogActions>
     
    </>
  );
};

export default AddAgendaPopup;
